import { Component, Input, OnInit, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { merge } from 'rxjs';
import { LayerType, legendStateContainer, legendStateItem, mapLayer } from 'src/app/interfaces/common';
import { LayerService } from 'src/app/services/layer.service';

@Component({
  selector: 'app-legend-bar',
  standalone: true,
  templateUrl: './legend-bar.component.html',
  styleUrl: './legend-bar.component.css'
})
export class LegendBarComponent implements OnInit {

  @Input() mapLayers: mapLayer[] = [];
  @Input() applicationSettings: any;
  activeLegends: legendStateItem[] = [];
  private destroyRef = inject(DestroyRef);

  constructor(private layerService: LayerService) { }

  ngOnInit(): void {
    merge(
      this.layerService.getNewMaplayersStatus(),
      this.layerService.legendState$,
      this.layerService.layerOrderChanged$
    )
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        const legendState = this.layerService.legendState$.getValue();
        this.computeActiveLegends(legendState);
      });
  }

  private computeActiveLegends(legendState: legendStateContainer): void {
    if (!this.mapLayers || !legendState) return;

    const applyAllLayers = this.applicationSettings?.option?.legendBar?.applyAllLayers === true;

    this.activeLegends = this.mapLayers
      .slice() // Shallow copy to avoid mutating the copy on sort()
      .sort((a, b) =>
        this.layerService.getZIndex(b.id) -
        this.layerService.getZIndex(a.id)
      )
      //.map((layer) => {
        //console.log(layer)
        //return layer
      //})
      // Filter only layers that can have legends
      .filter(layer =>
        layer.checked === true &&
        layer.basemap !== true &&
        layer.type !== LayerType.GROUP &&
        layer.type !== LayerType.VEKTOR
      )

      // Filter on either all legend layers (applyAllLayers is true) or only the marked ones (applyAllLayers is false/undefined)
      .filter(layer => applyAllLayers ? true : layer?.option?.mp_layer?.legend?.showOnLegendBar === true)
      .map(layer => {
        const legend = legendState[layer.id];
        const hasURL = (legend.legendURL?.trim() ?? '').length > 0;
        if (legend?.legendOn === true && hasURL) {
          const hideTitle = layer.option?.mp_layer?.legend?.hideTitle === true;
          const title: string = hideTitle ? '' : (layer.option?.mp_layer?.legend?.title ?? layer.title ?? layer.name ?? '');
          return { ...legend, title };
        }
        return null;
      })
      .filter(legend => legend !== null) as legendStateItem[];  // Remove nulls
  }
}